import React from "react";

import DriverInfoInput from "./DriverInfoInput";
import { isMaxDayToInput, isMaxMonthToInput } from "../driver-fields-validations";

function DriverDateInput({
  t,
  label,
  labelComp,
  dayValue,
  monthValue,
  yearValue,
  dayName,
  monthName,
  yearName,
  onDayChange,
  onMonthChange,
  onYearChange,
  validationObject,
  disabled,
  autoNextFocus,
}) {
  const hasError = (!validationObject?.isValid) || false

  const monthRef = React.useRef()
  const yearRef = React.useRef()

  return (
    <div className="text-center">
      <label htmlFor={dayName}>
        {labelComp ? labelComp : <span>{label}</span>}
      </label>
      <div className="row">
        <div className="col">
          <label htmlFor={dayName}>{t("day")}</label>
          <DriverInfoInput
            value={dayValue}
            onChange={(e) => {
              const value = e.target.value
              onDayChange(value)
              isMaxDayToInput(value) && monthRef.current.focus()
            }}
            id={dayName}
            type="numeric"
            placeholder="DD"
            error={!validationObject?.isValid}
            disabled={disabled}
          />
        </div>
        <div className="col">
          <label ref={monthRef} htmlFor={monthName}>{t("month")}</label>
          <DriverInfoInput
            value={monthValue}
            onChange={(e) => {
              const value = e.target.value
              onMonthChange(value)
              isMaxMonthToInput(value) && yearRef.current.focus()
            }}
            id={monthName}
            type="numeric"
            error={!validationObject.isValid}
            placeholder="MM"
            disabled={disabled}
          />
        </div>
        <div className="col">
          <label ref={yearRef} htmlFor={yearName}>{t("year")}</label>
          <DriverInfoInput
            value={yearValue}
            onChange={(e) => onYearChange(e.target.value)}
            id={yearName}
            type="numeric"
            placeholder="YYYY"
            error={!validationObject.isValid}
            disabled={disabled}
          />
        </div>
      </div>
      {hasError && <div style={{ textAlign: 'center', color: '#EE7402', fontSize: '12px' }}>{validationObject?.message}</div>}
    </div>
  );
}

export default DriverDateInput;
